import { defineComponent } from '@vue/composition-api'

export const BCardList = defineComponent({
  name: 'BCardList',
  render() {
    return <div class="px-6 pt-4 pb-2 overflow-auto h-full">{this.$slots.default}</div>
  },
})
